import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

import Default from '../containers/Default.vue'
import PaymentDefault from '../containers/PaymentDefault.vue'

import Selector from '../views/card/Selector.vue'
import Domestic from '../views/card/Domestic.vue'
import Global from '../views/card/Global.vue'
import Certification from '../views/payment/Certification.vue'
import Complete from '../views/pages/Complete.vue'
import Failure from '../views/pages/Failure.vue'
import Skeleton from '../views/pages/SkeletonScreen.vue'

import Index from '../views/pages/Index.vue'
import NotFound from '../views/pages/NotFound.vue'
import TempClose from '../views/payment/TempClose.vue'

Vue.use(Router)

let routes = [
  {
    path: '/',
    name: 'Skeleton',
    component: Skeleton
  },
  {
    path: '/main',
    name: 'Main',
    component: Index
  },  
  {
    path: '/page',
    redirect: '',
    name: 'Default',
    component: Default,
    children: [
      {
        path: 'complete',
        name: 'Complete',
        component: Complete
      },
      {
        path: 'failure',
        name: 'Failure',
        component: Failure
      },
    ]
  },
  {
    path: '/payment',
    redirect: '',
    name: 'PaymentDefault',
    component: PaymentDefault,
    children: [
      {
        path: 'selector',
        name: 'Selector',
        component: Selector
      },
      {
        path: 'domestic',
        name: 'Domestic',
        component: Domestic
      },
      {
        path: 'global',
        name: 'Global',
        component: Global
      },
      {
        path: 'certification',
        name: 'Certification',
        component: Certification
      },
      {
        path: 'close',
        name: 'TempClose',
        cpmonent: TempClose
      }
    ]
  },
  {
    path: '/*',
    name: 'NotFound',
    component: Failure,
    beforeEnter: async (from, to, next) => {
      await store.dispatch("SET_ERROR_PAGE", {
        message: '잘못된 접근입니다.',
        code: '404'
      })
      next();
    }
  }
];

const router = new Router({
  mode: 'history', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes,
  beforeEach: ((to, from, next) => {
    next();
  })
})

router.beforeResolve((to, from, next) => {
  next();
})

export default router;
